﻿import { ThemeProvider } from 'shared-ui';
import type { ReactNode } from 'react';
import { useLocalStorage, useMediaQuery } from 'usehooks-ts';

type Theme = 'light' | 'dark';

const themeStorageKey = 'orbit-theme';

export interface PersistentThemeProviderProps {
    children: ReactNode;
}

export function PersistentThemeProvider({ children }: PersistentThemeProviderProps) {
    const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
    const [theme, setTheme] = useLocalStorage<Theme>(themeStorageKey, prefersDark ? 'dark' : 'light');

    return (
        <ThemeProvider
            mode={theme}
            onModeChange={(mode) => {
                if (mode !== 'system') {
                    setTheme(mode);
                } else {
                    setTheme(prefersDark ? 'dark' : 'light');
                }
            }}
        >
            {children}
        </ThemeProvider>
    );
}
